import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import icons from '@common/icons';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseIcon',
  props: {
    icon: null,
    color: null,
    size: null
  },
  setup(__props) {
    const props = __props;
    const iconToUse = computed(() => {
      const key = props.icon.startsWith('$') ? props.icon.replace('$', '') : props.icon;
      return icons[key] ?? props.icon ?? '';
    });
    const classes = computed(() => {
      const results = [];
      if (props.color) results.push(`text-${props.color}`);
      return results.join(' ');
    });
    return {
      __sfc: true,
      props,
      iconToUse,
      classes,
      FontAwesomeIcon
    };
  }
});